/**
 * CreaDTF · comportamiento del tema.
 * - Contadores (−/+) de metros.
 * - Calculadora de precio por tramo (home) y resumen de la ficha de producto.
 * - Aprobación obligatoria antes de añadir al carrito, con sello de fecha.
 * - Actualización automática del carrito al cambiar los metros.
 */
(() => {
  const money = (n) =>
    n.toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  /** «1:11.95,5:10.75» → [[1, 11.95], [5, 10.75]] ordenado por metros */
  const parseTiers = (value) =>
    (value || '')
      .split(',')
      .map((t) => t.split(':').map((x) => parseFloat(x)))
      .filter((t) => t.length === 2 && !Number.isNaN(t[0]) && !Number.isNaN(t[1]))
      .sort((a, b) => a[0] - b[0]);

  const tierFor = (tiers, meters) => {
    let price = tiers.length ? tiers[0][1] : 0;
    let next = null;
    for (const tier of tiers) {
      if (meters >= tier[0]) price = tier[1];
      else {
        next = tier;
        break;
      }
    }
    return { price, next };
  };

  /** Metros facturados: mínimo del pedido y metros completos */
  const billedMeters = (value, min) => Math.max(min, Math.ceil(parseFloat(value) || min));

  // Contadores −/+
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-step]');
    if (!button) return;
    const input = button.closest('[data-stepper]')?.querySelector('input');
    if (!input) return;
    const min = parseFloat(input.min || '0');
    const next = Math.max(min, (parseFloat(input.value) || 0) + parseFloat(button.dataset.step));
    input.value = String(next);
    input.dispatchEvent(new Event('input', { bubbles: true }));
  });

  // Calculadora de la home
  document.querySelectorAll('[data-price-calc]').forEach((root) => {
    const tiers = parseTiers(root.dataset.tiers);
    const min = parseFloat(root.dataset.min) || 1;
    const plusTax = root.dataset.plusTax === 'true';
    const input = root.querySelector('[data-price-calc-input]');
    const output = root.querySelector('[data-price-calc-output]');
    if (!input || !output || !tiers.length) return;

    const update = () => {
      const meters = billedMeters(input.value, min);
      const { price } = tierFor(tiers, meters);
      output.textContent = '= ' + money(meters * price) + (plusTax ? ' + IVA' : '');
    };
    input.addEventListener('input', update);
    update();
  });

  // Ficha de producto: resumen y aprobación
  document.querySelectorAll('[data-dtf-form]').forEach((form) => {
    const tiers = parseTiers(form.dataset.tiers);
    const min = parseFloat(form.dataset.min) || 1;
    const plusTax = form.dataset.plusTax === 'true';
    const quantity = form.querySelector('[name="quantity"]');
    const out = (key) => form.querySelector(`[data-out="${key}"]`);

    const updatePrice = () => {
      if (!quantity || !tiers.length) return;
      const meters = billedMeters(quantity.value, min);
      const { price, next } = tierFor(tiers, meters);
      out('price').textContent = money(price);
      out('subtotal').textContent = money(meters * price) + (plusTax ? ' + IVA' : '');
      out('next').textContent = next
        ? `Desde ${next[0]} m el metro baja a ${money(next[1])}`
        : 'Ya tienes el mejor precio por metro';
    };
    quantity?.addEventListener('input', updatePrice);
    quantity?.addEventListener('change', () => {
      quantity.value = String(billedMeters(quantity.value, min));
      updatePrice();
    });
    updatePrice();

    const checks = [...form.querySelectorAll('[data-approval]')];
    const submit = form.querySelector('[type="submit"][name="add"]');
    const pending = out('pending');

    // El configurador (dtf-configurator.js) deja en `form.dataset.blocker` lo
    // que impide añadir al carrito: falta el archivo, hay errores o avisos.
    const syncApproval = () => {
      const blocker = form.dataset.blocker || '';
      const missing = checks.filter((c) => !c.checked).length;
      submit?.setAttribute('aria-disabled', blocker || missing ? 'true' : 'false');
      if (pending) {
        if (blocker) pending.textContent = blocker;
        else if (missing) pending.textContent = `Falta: ${missing} ${missing === 1 ? 'casilla' : 'casillas'}`;
        else pending.textContent = 'Todo listo';
      }
    };
    form.dtfSync = syncApproval;
    checks.forEach((c) => c.addEventListener('change', syncApproval));
    syncApproval();

    form.addEventListener('submit', (event) => {
      if (form.dataset.blocker) {
        event.preventDefault();
        syncApproval();
        document.querySelector('[data-dtf-configurator]')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      const firstMissing = checks.find((c) => !c.checked);
      if (firstMissing) {
        event.preventDefault();
        firstMissing.focus();
        return;
      }
      const stamp = form.querySelector('[name="properties[_Aprobación]"]');
      if (stamp) stamp.value = new Date().toISOString();
    });
  });

  // Carrito: envía el formulario al cambiar los metros
  document.querySelectorAll('[data-cart-form]').forEach((form) => {
    let timer;
    form.addEventListener('input', (event) => {
      if (!event.target.matches('[name="updates[]"]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => form.submit(), 600);
    });
  });
})();
